/**
 * An amount in Lithuanian words, as cash orders and some invoices write it: "Vienas tūkstantis du šimtai
 * trisdešimt keturi eurai 56 ct". Nouns agree with the number: 1 (but not 11) the singular, 2–9 the plural,
 * 10–20 and round tens the genitive plural.
 */
const ONES = ['', 'vienas', 'du', 'trys', 'keturi', 'penki', 'šeši', 'septyni', 'aštuoni', 'devyni'];
const TEENS = ['dešimt', 'vienuolika', 'dvylika', 'trylika', 'keturiolika', 'penkiolika', 'šešiolika', 'septyniolika', 'aštuoniolika', 'devyniolika'];
const TENS = ['', '', 'dvidešimt', 'trisdešimt', 'keturiasdešimt', 'penkiasdešimt', 'šešiasdešimt', 'septyniasdešimt', 'aštuoniasdešimt', 'devyniasdešimt'];
/** The form of a noun for a number: [singular, plural, genitive plural]. */
export function ltForm(n, forms) {
    const last2 = n % 100, last = n % 10;
    if (last2 >= 10 && last2 <= 20)
        return forms[2];
    if (last === 1)
        return forms[0];
    if (last === 0)
        return forms[2];
    return forms[1];
}
/** 0–999 in words (empty for 0). */
function hundreds(n) {
    const out = [];
    const h = Math.floor(n / 100), rest = n % 100;
    if (h)
        out.push(h === 1 ? 'šimtas' : `${ONES[h]} šimtai`);
    if (rest >= 10 && rest < 20)
        out.push(TEENS[rest - 10]);
    else {
        if (rest >= 20)
            out.push(TENS[Math.floor(rest / 10)]);
        if (rest % 10)
            out.push(ONES[rest % 10]);
    }
    return out.join(' ');
}
/** A whole number in words ("nulis" for 0), up to 999 999 999 999. */
export function ltNumber(n) {
    n = Math.floor(Math.abs(n));
    if (n === 0)
        return 'nulis';
    const billions = Math.floor(n / 1_000_000_000) % 1000;
    n %= 1_000_000_000;
    const millions = Math.floor(n / 1_000_000), thousands = Math.floor((n % 1_000_000) / 1000), rest = n % 1000;
    const out = [];
    if (billions)
        out.push(`${hundreds(billions)} ${ltForm(billions, ['milijardas', 'milijardai', 'milijardų'])}`);
    if (millions)
        out.push(`${hundreds(millions)} ${ltForm(millions, ['milijonas', 'milijonai', 'milijonų'])}`);
    if (thousands)
        out.push(`${hundreds(thousands)} ${ltForm(thousands, ['tūkstantis', 'tūkstančiai', 'tūkstančių'])}`);
    if (rest)
        out.push(hundreds(rest));
    return out.join(' ');
}
/** Cents as "Šimtas dvidešimt trys eurai 45 ct". */
export function ltAmountWords(cents) {
    const abs = Math.abs(Math.round(cents));
    const euros = Math.floor(abs / 100), ct = abs % 100;
    const text = `${ltNumber(euros)} ${ltForm(euros, ['euras', 'eurai', 'eurų'])} ${String(ct).padStart(2, '0')} ct`;
    return (cents < 0 ? 'minus ' : '') + text.charAt(0).toUpperCase() + text.slice(1);
}
//# sourceMappingURL=words.js.map